<template>
  <div v-if="isFlashVisible" :class="['flash-message', flashType]">
    {{ flashMessage }}
  </div>
</template>

<script>
import { computed } from 'vue';
import { useStore } from 'vuex';

export default {
  setup() {
    const store = useStore();
    const flashMessage = computed(() => store.state.flashMessage);
    const flashType = computed(() => store.state.flashType);
    const isFlashVisible = computed(() => store.state.isFlashVisible);

    return { flashMessage, flashType, isFlashVisible };
  }
};
</script>

<style scoped>
.flash-message {
  position: fixed;
  top: 20px;
  right: 20px;
  color: white;
  padding: 10px 20px;
  border-radius: 5px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
  z-index: 10000;
}

.success {
  background-color: green;
}
.danger {
  background-color: red;
}
.warning {
  background-color: yellow;
}
</style>
